import { useState } from "react";
import { Link, useNavigate, useLocation} from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

const ROLES = [
  {
    id: "client",
    label: "Client / Visiteur",
    desc: "Je cherche des logements, restaurants et transports",
    icon: "",
  },
  {
    id: "chauffeur",
    label: "Chauffeur",
    desc: "Je propose des services de transport et location de véhicule",
    icon: "",
  },
  {
  id: "loueur",
  label: "Loueur de véhicule",
  desc: "Je propose des véhicules à la location pour les touristes",
  icon: "",
},
  {
    id: "bailleur",
    label: "Bailleur",
    desc: "Je loue une auberge, un appartement meublé ou un studio",
    icon: "",
  },
  {
    id: "restaurateur",
    label: "Restaurateur",
    desc: "Je gère un restaurant ou un espace de restauration",
    icon: "",
  },
  {
    id: "guide",
    label: "Guide touristique",
    desc: "J'accompagne les visiteurs et fais découvrir les sites touristiques",
    icon: "",
  },
  {
    id: "artisan",
    label: "Artisan",
    desc: "Je propose des produits artisanaux et des services locaux",
    icon: "",
  },
  {
    id: "loisir",
    label: "Loisirs & Activités",
    desc: "Je propose des activités de loisirs, excursions ou expériences touristiques",
    icon: "",
  },
];

const features = [
  {
    label: "Hôtels & Restaurants",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.8">
        <rect x="2" y="7" width="20" height="15" rx="2"/><path d="M2 10h20"/>
        <rect x="9" y="14" width="6" height="8" rx="1"/>
      </svg>
    ),
  },
  {
    label: "Sites touristiques",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.8">
        <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z"/>
        <circle cx="12" cy="10" r="3"/>
      </svg>
    ),
  },
  {
    label: "Transport facile",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.8">
        <rect x="1" y="3" width="15" height="13" rx="2"/>
        <path d="M16 8h4l3 3v5h-7V8z"/>
        <circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
      </svg>
    ),
  },
  {
    label: "Paiement sécurisé",
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.8">
        <rect x="1" y="4" width="22" height="16" rx="2"/>
        <line x1="1" y1="10" x2="23" y2="10"/>
      </svg>
    ),
  },
];

export default function Inscription() {
  const navigate = useNavigate();
  const [etape, setEtape]                     = useState(0);
  const [showPassword, setShowPassword]       = useState(false);
  const location = useLocation();
  const [roleSelectionne, setRoleSelectionne] = useState(location.state?.role || null);
  const [focusedField, setFocusedField]       = useState(null);
  const [errors, setErrors]                   = useState({});

  const [formData, setFormData] = useState({
    prenom: "", nom: "", email: "", telephone: "", password: "",
  });

  const [extraData, setExtraData] = useState({
    vehicule_marque: "", vehicule_modele: "", vehicule_plaque: "",
    type_logement: "", adresse_logement: "", ville_logement: "",
    nom_restaurant: "", adresse_restaurant: "", ville_restaurant: "",
    specialite_artisan: "", nom_boutique: "", ville_artisan: "",
    langues_guide: "", zone_guidage: "", licence_guide: "",
    nb_vehicules: "", types_vehicules: [], ville_loueur: "", adresse_parking: "", whatsapp_loueur: "", email_pro_loueur: "",
    type_activite_loisir: "", nom_activite_loisir: "", ville_loisir: "", whatsapp_loisir: "",
  });

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
  const handleExtra  = (e) => setExtraData({ ...extraData, [e.target.name]: e.target.value });

  const validerEtape1 = () => {
    const e = {};
    if (!formData.prenom.trim())    e.prenom    = "Obligatoire";
    if (!formData.nom.trim())       e.nom       = "Obligatoire";
    if (!formData.email.trim())     e.email     = "Obligatoire";
    if (!formData.telephone.trim()) e.telephone = "Obligatoire";
    if (formData.password.length < 8) e.password = "Minimum 8 caractères";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSuivant = () => {
    if (etape === 1) {
      if (!validerEtape1()) return;
      if (roleSelectionne === "client") {
        handleSoumettre();
        return;
      }
    }
    setErrors({});
    setEtape(e => e + 1);
  };

  const handleSoumettre = async () => {
    try {
      const res = await fetch("https://senutour.com/api/auth/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          nom: formData.nom,
          prenom: formData.prenom,
          email: formData.email,
          telephone: formData.telephone,
          password: formData.password,
          role: roleSelectionne,
          typeEtablissement: extraData.type_logement || null,
          ville: extraData.ville_logement || extraData.ville_restaurant || extraData.ville_loisir || null,
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));

     switch (roleSelectionne) {
  case "chauffeur":
    navigate("/chauffeur");
    break;
  case "bailleur":
    navigate("/bailleur");
    break;
  case "restaurateur":
    navigate("/restaurateur");
    break;
  case "guide":
    navigate("/guide");
    break;
  case "artisan":
    navigate("/artisan");
    break;
  case "loueur":
    navigate("/loueur");
    break;
 case "loisir":
  navigate("/dashboard/loisir");
  break;
  default:
    navigate("/");
}
     
    } catch (error) {
      alert("Erreur : " + error.message);
    }
  };

  const inputStyle = (field) => ({
    width: "100%",
    padding: "13px 18px 13px 42px",
    border: `2px solid ${errors[field] ? "#E53E3E" : focusedField === field ? "#C4441A" : "#E8DCC8"}`,
    borderRadius: 10,
    fontFamily: "'Space Grotesk', sans-serif",
    fontSize: 14,
    color: "#1C1008",
    background: "white",
    outline: "none",
    transition: "border-color .25s, box-shadow .25s",
    boxSizing: "border-box",
    boxShadow: focusedField === field ? "0 0 0 3px rgba(196,68,26,0.10)" : "none",
  });

  const inputExtraStyle = (field) => ({
    ...inputStyle(field),
    padding: "13px 18px",
  });

  const labelStyle = {
    display: "block", fontSize: 11, fontWeight: 600,
    color: "#7A5A3A", textTransform: "uppercase",
    letterSpacing: "0.5px", marginBottom: 5,
  };

  const PanneauGauche = () => (
    <div className="auth-left" style={{
      width: "42%", background: "#C4441A", padding: "48px 36px",
      display: "flex", flexDirection: "column", justifyContent: "space-between",
      position: "relative", overflow: "hidden", flexShrink: 0,
    }}>
      <div style={{ position:"absolute", width:280, height:280, borderRadius:"50%", border:"45px solid rgba(255,255,255,0.07)", bottom:-90, left:-90 }} />
      <div style={{ position:"absolute", width:180, height:180, borderRadius:"50%", border:"35px solid rgba(255,255,255,0.06)", top:-50, right:-50 }} />

      <div style={{ position:"relative", zIndex:1, display:"flex", alignItems:"center", gap:8 }}>
        <div style={{ width:32, height:32, borderRadius:8, background:"rgba(255,255,255,0.2)", display:"flex", alignItems:"center", justifyContent:"center" }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
            <path d="M12 2C8 6 4 8 4 14a8 8 0 0 0 16 0c0-6-4-8-8-12z"/>
          </svg>
        </div>
        <span style={{ fontFamily:"'Fraunces',serif", fontSize:20, fontWeight:800, color:"white", letterSpacing:"-0.5px" }}>
          Sunu<span style={{ color:"rgba(255,255,255,0.5)" }}>Tour</span>
        </span>
      </div>

      <div style={{ position:"relative", zIndex:1 }}>
        <div style={{ display:"inline-flex", alignItems:"center", gap:6, background:"rgba(255,255,255,0.15)", borderRadius:20, padding:"6px 14px", marginBottom:16 }}>
          <span style={{ fontSize:14 }}></span>
          <span style={{ fontSize:11, fontWeight:700, color:"white", letterSpacing:1 }}>JOJ DAKAR 2026</span>
        </div>
        <h2 style={{ fontFamily:"'Fraunces',serif", fontSize:"clamp(20px,2.5vw,28px)", fontWeight:700, color:"white", lineHeight:1.25, marginBottom:12 }}>
          Découvrez le Sénégal autrement
        </h2>
        <p style={{ fontSize:13, color:"rgba(255,255,255,0.70)", lineHeight:1.7, margin:0 }}>
          Dakar · Diamniadio · Saly — tout ce dont vous avez besoin pour les JOJ.
        </p>
      </div>

      <div style={{ position:"relative", zIndex:1, display:"flex", flexDirection:"column", gap:10 }}>
        {features.map((f) => (
          <div key={f.label} className="feature-pill" style={{
            display:"flex", alignItems:"center", gap:10,
            background:"rgba(255,255,255,0.12)", borderRadius:50,
            padding:"9px 16px", color:"white", fontSize:13, fontWeight:500,
          }}>
            {f.icon}{f.label}
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <>
      <Navbar />
      <div style={{
        fontFamily: "'Space Grotesk', sans-serif",
        background: "#FAF5EC", minHeight: "100vh",
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: "24px 16px",
      }}>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,300;0,9..144,700;0,9..144,800;1,9..144,400&family=Space+Grotesk:wght@300;400;500;600;700&display=swap');
          .btn-submit { background: #C4441A; transition: background .2s, transform .2s; }
          .btn-submit:hover { background: #A03614; transform: translateY(-1px); }
          .btn-submit:disabled { background: #B89A7A; cursor: not-allowed; transform: none; }
          .feature-pill { transition: background .2s; }
          .feature-pill:hover { background: rgba(255,255,255,0.18) !important; }
          .link-login { color: #C4441A; transition: color .2s; text-decoration: none; font-weight: 600; }
          .link-login:hover { color: #A03614; }
          .eye-btn { transition: color .2s; }
          .eye-btn:hover { color: #C4441A !important; }
          .role-card { transition: all .2s; cursor: pointer; }
          .role-card:hover { border-color: #C4441A !important; background: rgba(196,68,26,0.03) !important; }
          @media (max-width: 767px) {
            .auth-card { flex-direction: column !important; }
            .auth-left { width: 100% !important; padding: 32px 24px !important; }
            .auth-right { padding: 32px 24px !important; }
            .name-grid { grid-template-columns: 1fr !important; }
            .roles-grid { grid-template-columns: 1fr !important; }
          }
        `}</style>

        <div className="auth-card" style={{
          width: "100%", maxWidth: etape === 0 ? 960 : 900,
          background: "white", borderRadius: 16, overflow: "hidden",
          boxShadow: "0 4px 40px rgba(28,16,8,0.10)",
          display: "flex", minHeight: 620,
          transition: "max-width .3s",
        }}>
          <PanneauGauche />

          <div className="auth-right" style={{
            flex: 1, background: "#FAF5EC",
            padding: "48px 40px",
            display: "flex", flexDirection: "column", justifyContent: "center",
            overflowY: "auto",
          }}>

            {/* ════ ÉTAPE 0 : CHOIX DU RÔLE ════ */}
            {etape === 0 && (
              <>
                <div style={{ marginBottom: 6 }}>
                  <span style={{ fontSize:11, fontWeight:700, color:"#C4441A", textTransform:"uppercase", letterSpacing:2 }}>Bienvenue</span>
                </div>
                <h1 style={{ fontFamily:"'Fraunces',serif", fontSize:"clamp(20px,3vw,26px)", fontWeight:800, color:"#1C1008", margin:"0 0 6px" }}>
                  Vous êtes ?
                </h1>
                <p style={{ fontSize:13, color:"#7A5A3A", margin:"0 0 28px", lineHeight:1.6 }}>
                  Sélectionnez votre profil pour personnaliser votre inscription.
                </p>

                <div className="roles-grid" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:28 }}>
                  {ROLES.map(r => (
                    <div key={r.id} className="role-card"
                      onClick={() => setRoleSelectionne(r.id)}
                      style={{
                        background: roleSelectionne === r.id ? "rgba(196,68,26,0.05)" : "white",
                        border: `2px solid ${roleSelectionne === r.id ? "#C4441A" : "#E8DCC8"}`,
                        borderRadius: 12, padding: "16px",
                        display: "flex", alignItems: "flex-start", gap: 12,
                        boxShadow: roleSelectionne === r.id ? "0 4px 16px rgba(196,68,26,0.12)" : "none",
                      }}>
                      <div style={{
                        width: 20, height: 20, borderRadius: 6, flexShrink: 0, marginTop: 2,
                        border: `2px solid ${roleSelectionne === r.id ? "#C4441A" : "#E8DCC8"}`,
                        background: roleSelectionne === r.id ? "#C4441A" : "white",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        transition: "all .2s",
                      }}>
                        {roleSelectionne === r.id && (
                          <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
                            <polyline points="20 6 9 17 4 12"/>
                          </svg>
                        )}
                      </div>
                      <div>
                        <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:4 }}>
                          <span style={{ fontSize:18 }}>{r.icon}</span>
                          <span style={{ fontSize:14, fontWeight:700, color:"#1C1008" }}>{r.label}</span>
                        </div>
                        <p style={{ fontSize:12, color:"#7A5A3A", margin:0, lineHeight:1.5 }}>{r.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <button className="btn-submit" disabled={!roleSelectionne}
                  onClick={() => setEtape(1)}
                  style={{
                    width:"100%", padding:"14px", color:"white", border:"none",
                    borderRadius:10, fontFamily:"'Space Grotesk',sans-serif",
                    fontSize:15, fontWeight:700, cursor: roleSelectionne ? "pointer" : "not-allowed",
                    display:"flex", alignItems:"center", justifyContent:"center", gap:8,
                    boxShadow: roleSelectionne ? "0 8px 20px rgba(196,68,26,0.30)" : "none",
                  }}>
                  Continuer →
                </button>

                <p style={{ textAlign:"center", fontSize:13, color:"#7A5A3A", marginTop:20 }}>
                  Déjà un compte ?{" "}
                  <Link to="/connexion" className="link-login">Se connecter</Link>
                </p>
              </>
            )}

            {/* ════ ÉTAPE 1 : INFOS COMMUNES ════ */}
            {etape === 1 && (
              <>
                <div style={{ display:"inline-flex", alignItems:"center", gap:6, background:"rgba(196,68,26,0.08)", borderRadius:20, padding:"5px 12px", marginBottom:16, alignSelf:"flex-start" }}>
                  <span style={{ fontSize:14 }}>{ROLES.find(r => r.id === roleSelectionne)?.icon}</span>
                  <span style={{ fontSize:12, fontWeight:700, color:"#C4441A" }}>{ROLES.find(r => r.id === roleSelectionne)?.label}</span>
                </div>

                <h1 style={{ fontFamily:"'Fraunces',serif", fontSize:"clamp(20px,3vw,26px)", fontWeight:800, color:"#1C1008", margin:"0 0 4px" }}>
                  Informations personnelles
                </h1>
                <p style={{ fontSize:13, color:"#7A5A3A", margin:"0 0 24px" }}>
                  {roleSelectionne === "client"
                    ? "Plus qu'une étape pour rejoindre SenuTour !"
                    : "Étape 1 sur 2 — vos informations de base."}
                </p>

                <div className="name-grid" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14, marginBottom:14 }}>
                  {[
                    { name:"prenom", label:"Prénom", placeholder:"Aminata" },
                    { name:"nom",    label:"Nom",    placeholder:"Diallo" },
                  ].map((f) => (
                    <div key={f.name}>
                      <label style={labelStyle}>{f.label}</label>
                      <div style={{ position:"relative" }}>
                        <span style={{ position:"absolute", left:13, top:"50%", transform:"translateY(-50%)", color:"#8B5E3C", display:"flex" }}>
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
                          </svg>
                        </span>
                        <input type="text" name={f.name} placeholder={f.placeholder}
                          value={formData[f.name]} onChange={handleChange}
                          onFocus={() => setFocusedField(f.name)}
                          onBlur={() => setFocusedField(null)}
                          style={inputStyle(f.name)}
                        />
                      </div>
                      {errors[f.name] && <span style={{ fontSize:11, color:"#E53E3E", marginTop:3, display:"block" }}>{errors[f.name]}</span>}
                    </div>
                  ))}
                </div>

                <div style={{ marginBottom:14 }}>
                  <label style={labelStyle}>Adresse email</label>
                  <div style={{ position:"relative" }}>
                    <span style={{ position:"absolute", left:13, top:"50%", transform:"translateY(-50%)", color:"#8B5E3C", display:"flex" }}>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                        <polyline points="22,6 12,13 2,6"/>
                      </svg>
                    </span>
                    <input type="email" name="email" placeholder="aminata@exemple.com"
                      value={formData.email} onChange={handleChange}
                      onFocus={() => setFocusedField("email")}
                      onBlur={() => setFocusedField(null)}
                      style={inputStyle("email")}
                    />
                  </div>
                  {errors.email && <span style={{ fontSize:11, color:"#E53E3E", marginTop:3, display:"block" }}>{errors.email}</span>}
                </div>

                <div style={{ marginBottom:14 }}>
                  <label style={labelStyle}>Téléphone</label>
                  <div style={{ position:"relative" }}>
                    <span style={{ position:"absolute", left:13, top:"50%", transform:"translateY(-50%)", color:"#8B5E3C", display:"flex" }}>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.01 1.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92v2z"/>
                      </svg>
                    </span>
                    <input type="tel" name="telephone" placeholder="+221 77 000 00 00"
                      value={formData.telephone} onChange={handleChange}
                      onFocus={() => setFocusedField("telephone")}
                      onBlur={() => setFocusedField(null)}
                      style={inputStyle("telephone")}
                    />
                  </div>
                  {errors.telephone && <span style={{ fontSize:11, color:"#E53E3E", marginTop:3, display:"block" }}>{errors.telephone}</span>}
                </div>

                <div style={{ marginBottom:24 }}>
                  <label style={labelStyle}>Mot de passe</label>
                  <div style={{ position:"relative" }}>
                    <span style={{ position:"absolute", left:13, top:"50%", transform:"translateY(-50%)", color:"#8B5E3C", display:"flex" }}>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="3" y="11" width="18" height="11" rx="2"/>
                        <path d="M7 11V7a5 5 0 0110 0v4"/>
                      </svg>
                    </span>
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password" placeholder="Minimum 8 caractères"
                      value={formData.password} onChange={handleChange}
                      onFocus={() => setFocusedField("password")}
                      onBlur={() => setFocusedField(null)}
                      style={{ ...inputStyle("password"), paddingRight:44 }}
                    />
                    <button type="button" className="eye-btn"
                      onClick={() => setShowPassword(!showPassword)}
                      style={{ position:"absolute", right:13, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", color:"#8B5E3C", display:"flex", padding:0 }}>
                      {showPassword ? (
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/>
                          <line x1="1" y1="1" x2="23" y2="23"/>
                        </svg>
                      ) : (
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                          <circle cx="12" cy="12" r="3"/>
                        </svg>
                      )}
                    </button>
                  </div>
                  {errors.password && <span style={{ fontSize:11, color:"#E53E3E", marginTop:3, display:"block" }}>{errors.password}</span>}
                </div>

                <div style={{ display:"flex", gap:12 }}>
                  <button onClick={() => setEtape(0)}
                    style={{ background:"white", border:"1.5px solid #E8DCC8", borderRadius:10, padding:"13px 20px", fontSize:14, fontWeight:600, color:"#7A5A3A", cursor:"pointer" }}>
                    ← Retour
                  </button>
                  <button className="btn-submit" onClick={handleSuivant}
                    style={{ flex:1, padding:"13px", color:"white", border:"none", borderRadius:10, fontFamily:"'Space Grotesk',sans-serif", fontSize:15, fontWeight:700, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:8, boxShadow:"0 8px 20px rgba(196,68,26,0.30)" }}>
                    {roleSelectionne === "client" ? "Créer mon compte ✓" : "Continuer →"}
                  </button>
                </div>

                <p style={{ textAlign:"center", fontSize:13, color:"#7A5A3A", marginTop:20 }}>
                  Déjà un compte ?{" "}
                  <Link to="/connexion" className="link-login">Se connecter</Link>
                </p>
              </>
            )}

            {/* ════ ÉTAPE 2 : INFOS SPÉCIFIQUES AU RÔLE ════ */}
            {etape === 2 && (
              <>
                <div style={{ display:"inline-flex", alignItems:"center", gap:6, background:"rgba(196,68,26,0.08)", borderRadius:20, padding:"5px 12px", marginBottom:16, alignSelf:"flex-start" }}>
                  <span style={{ fontSize:14 }}>{ROLES.find(r => r.id === roleSelectionne)?.icon}</span>
                  <span style={{ fontSize:12, fontWeight:700, color:"#C4441A" }}>{ROLES.find(r => r.id === roleSelectionne)?.label}</span>
                </div>

                <h1 style={{ fontFamily:"'Fraunces',serif", fontSize:"clamp(20px,3vw,26px)", fontWeight:800, color:"#1C1008", margin:"0 0 4px" }}>
                  {roleSelectionne === "chauffeur"    && "Votre véhicule"}
                  {roleSelectionne === "bailleur"     && "Votre logement"}
                  {roleSelectionne === "restaurateur" && "Votre restaurant"}
                  {roleSelectionne === "artisan"      && "Votre boutique"}
                  {roleSelectionne === "guide"        && "Votre profil de guide"}
                  {roleSelectionne === "loueur"       && "Votre parc de véhicules"}
                  {roleSelectionne === "loisir"       && "Votre activité"}
                </h1>
                <p style={{ fontSize:13, color:"#7A5A3A", margin:"0 0 24px", lineHeight:1.6 }}>
                  Étape 2 sur 2 — ces informations seront vérifiées par notre équipe.
                </p>

                {/* ── Chauffeur ── */}
                {roleSelectionne === "chauffeur" && (
                  <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
                    {[
                      { name:"vehicule_marque", label:"Marque du véhicule", placeholder:"Ex: Toyota" },
                      { name:"vehicule_modele", label:"Modèle",             placeholder:"Ex: Corolla" },
                      { name:"vehicule_plaque", label:"Numéro de plaque",   placeholder:"Ex: DK-1234-AB" },
                    ].map(f => (
                      <div key={f.name}>
                        <label style={labelStyle}>{f.label}</label>
                        <input name={f.name} placeholder={f.placeholder}
                          value={extraData[f.name]} onChange={handleExtra}
                          onFocus={() => setFocusedField(f.name)}
                          onBlur={() => setFocusedField(null)}
                          style={inputExtraStyle(f.name)}
                        />
                      </div>
                    ))}
                  </div>
                )}

                {/* ── Bailleur ── */}
                {roleSelectionne === "bailleur" && (
                  <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
                    <div>
                      <label style={labelStyle}>Type de logement</label>
                      <select name="type_logement" value={extraData.type_logement}
                        onChange={handleExtra}
                        style={{ ...inputExtraStyle("type_logement"), cursor:"pointer" }}>
                        <option value="">-- Sélectionner --</option>
                        <option value="auberge">Auberge</option>
                        <option value="appartement_meuble">Appartement meublé</option>
                        <option value="studio">Studio</option>
                        <option value="villa">Villa</option>
                      </select>
                    </div>
                    {[
                      { name:"adresse_logement", label:"Adresse du logement", placeholder:"Ex: Rue 10, Plateau" },
                      { name:"ville_logement",   label:"Ville",               placeholder:"Dakar, Diamniadio ou Saly" },
                    ].map(f => (
                      <div key={f.name}>
                        <label style={labelStyle}>{f.label}</label>
                        <input name={f.name} placeholder={f.placeholder}
                          value={extraData[f.name]} onChange={handleExtra}
                          onFocus={() => setFocusedField(f.name)}
                          onBlur={() => setFocusedField(null)}
                          style={inputExtraStyle(f.name)}
                        />
                      </div>
                    ))}
                  </div>
                )}

                {/* ── Restaurateur ── */}
                {roleSelectionne === "restaurateur" && (
                  <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
                    {[
                      { name:"nom_restaurant",     label:"Nom du restaurant",  placeholder:"Ex: La Teranga" },
                      { name:"adresse_restaurant", label:"Adresse",            placeholder:"Ex: Avenue Cheikh Anta Diop" },
                      { name:"ville_restaurant",   label:"Ville",              placeholder:"Dakar, Diamniadio ou Saly" },
                    ].map(f => (
                      <div key={f.name}>
                        <label style={labelStyle}>{f.label}</label>
                        <input name={f.name} placeholder={f.placeholder}
                          value={extraData[f.name]} onChange={handleExtra}
                          onFocus={() => setFocusedField(f.name)}
                          onBlur={() => setFocusedField(null)}
                          style={inputExtraStyle(f.name)}
                        />
                      </div>
                    ))}
                  </div>
                )}

                {/* ── Artisan ── */}
                {roleSelectionne === "artisan" && (
                  <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
                    <div>
                      <label style={labelStyle}>Spécialité</label>
                      <select name="specialite_artisan" value={extraData.specialite_artisan}
                        onChange={handleExtra}
                        style={{ ...inputExtraStyle("specialite_artisan"), cursor:"pointer" }}>
                        <option value="">-- Sélectionner --</option>
                        <option value="bijouterie">Bijouterie</option>
                        <option value="tissage">Tissage / Wax</option>
                        <option value="sculpture">Sculpture / Bois</option>
                        <option value="poterie">Poterie</option>
                        <option value="maroquinerie">Maroquinerie</option>
                        <option value="peinture">Peinture / Art</option>
                        <option value="autre">Autre</option>
                      </select>
                    </div>
                    {[
                      { name:"nom_boutique",  label:"Nom de la boutique", placeholder:"Ex: Artisanat Teranga" },
                      { name:"ville_artisan", label:"Ville",              placeholder:"Dakar, Diamniadio ou Saly" },
                    ].map(f => (
                      <div key={f.name}>
                        <label style={labelStyle}>{f.label}</label>
                        <input name={f.name} placeholder={f.placeholder}
                          value={extraData[f.name]} onChange={handleExtra}
                          onFocus={() => setFocusedField(f.name)}
                          onBlur={() => setFocusedField(null)}
                          style={inputExtraStyle(f.name)}
                        />
                      </div>
                    ))}
                  </div>
                )}

                {/* ── Guide ── */}
                {roleSelectionne === "guide" && (
                  <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
                    {[
                      { name:"langues_guide", label:"Langues parlées",   placeholder:"Ex: Français, Anglais, Wolof" },
                      { name:"zone_guidage",  label:"Zone de guidage",   placeholder:"Ex: Dakar, Île de Gorée, Saly" },
                      { name:"licence_guide", label:"Numéro de licence", placeholder:"Ex: GDE-2024-0123" },
                    ].map(f => (
                      <div key={f.name}>
                        <label style={labelStyle}>{f.label}</label>
                        <input name={f.name} placeholder={f.placeholder}
                          value={extraData[f.name]} onChange={handleExtra}
                          onFocus={() => setFocusedField(f.name)}
                          onBlur={() => setFocusedField(null)}
                          style={inputExtraStyle(f.name)}
                        />
                      </div>
                    ))}
                  </div>
                )}

                {/* ── Loueur ── */}
{roleSelectionne === "loueur" && (
  <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
    <div>
      <label style={labelStyle}>Nombre de véhicules disponibles</label>
      <input type="number" name="nb_vehicules" placeholder="Ex: 3"
        value={extraData.nb_vehicules} onChange={handleExtra}
        onFocus={() => setFocusedField("nb_vehicules")}
        onBlur={() => setFocusedField(null)}
        style={inputExtraStyle("nb_vehicules")}
      />
    </div>
    <div>
      <label style={labelStyle}>Types de véhicules proposés</label>
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        {["Berline", "SUV", "Minibus", "Pick-up", "Utilitaire"].map(type => (
          <label key={type} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, color: "#1C1008", cursor: "pointer" }}>
            <input type="checkbox"
              checked={extraData.types_vehicules.includes(type)}
              onChange={e => {
                const updated = e.target.checked
                  ? [...extraData.types_vehicules, type]
                  : extraData.types_vehicules.filter(t => t !== type);
                setExtraData({ ...extraData, types_vehicules: updated });
              }}
            />
            {type}
          </label>
        ))}
      </div>
    </div>
    <div>
      <label style={labelStyle}>Ville JOJ</label>
      <select name="ville_loueur" value={extraData.ville_loueur} onChange={handleExtra}
        style={{ ...inputExtraStyle("ville_loueur"), cursor: "pointer" }}>
        <option value="">-- Sélectionner --</option>
        <option value="Dakar">Dakar</option>
        <option value="Diamniadio">Diamniadio</option>
        <option value="Saly">Saly</option>
      </select>
    </div>
    {[
      { name: "adresse_parking",   label: "Adresse du parking",   placeholder: "Ex: Parking Liberté 6, Dakar" },
      { name: "whatsapp_loueur",   label: "Numéro WhatsApp",      placeholder: "Ex: +221 77 000 00 00" },
      { name: "email_pro_loueur",  label: "Email professionnel",  placeholder: "Ex: contact@monparc.com" },
    ].map(f => (
      <div key={f.name}>
        <label style={labelStyle}>{f.label}</label>
        <input name={f.name} placeholder={f.placeholder}
          value={extraData[f.name]} onChange={handleExtra}
          onFocus={() => setFocusedField(f.name)}
          onBlur={() => setFocusedField(null)}
          style={inputExtraStyle(f.name)}
        />
      </div>
    ))}
  </div>
)}

                {/* ── Loisirs & Activités ── */}
                {roleSelectionne === "loisir" && (
                  <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                    <div>
                      <label style={labelStyle}>Nom de l'activité proposée</label>
                      <input name="nom_activite_loisir" placeholder="Ex: Surf à Yoff, Visite de l'Île de Gorée…"
                        value={extraData.nom_activite_loisir} onChange={handleExtra}
                        onFocus={() => setFocusedField("nom_activite_loisir")}
                        onBlur={() => setFocusedField(null)}
                        style={inputExtraStyle("nom_activite_loisir")}
                      />
                    </div>
                    <div>
                      <label style={labelStyle}>Type d'activité</label>
                      <select name="type_activite_loisir" value={extraData.type_activite_loisir}
                        onChange={handleExtra}
                        style={{ ...inputExtraStyle("type_activite_loisir"), cursor: "pointer" }}>
                        <option value="">-- Sélectionner --</option>
                        <option value="Plage">Plage</option>
                        <option value="Culture">Culture</option>
                        <option value="Sport">Sport</option>
                        <option value="Nature">Nature</option>
                        <option value="Aventure">Aventure</option>
                        <option value="Bien-être">Bien-être</option>
                        <option value="Gastronomie">Gastronomie</option>
                        <option value="Nightlife">Nightlife</option>
                      </select>
                    </div>
                    <div>
                      <label style={labelStyle}>Ville</label>
                      <select name="ville_loisir" value={extraData.ville_loisir} onChange={handleExtra}
                        style={{ ...inputExtraStyle("ville_loisir"), cursor: "pointer" }}>
                        <option value="">-- Sélectionner --</option>
                        <option value="Dakar">Dakar</option>
                        <option value="Diamniadio">Diamniadio</option>
                        <option value="Saly">Saly</option>
                      </select>
                    </div>
                    <div>
                      <label style={labelStyle}>Numéro WhatsApp (contact client direct)</label>
                      <input name="whatsapp_loisir" placeholder="Ex: +221 77 000 00 00"
                        value={extraData.whatsapp_loisir} onChange={handleExtra}
                        onFocus={() => setFocusedField("whatsapp_loisir")}
                        onBlur={() => setFocusedField(null)}
                        style={inputExtraStyle("whatsapp_loisir")}
                      />
                    </div>
                  </div>
                )}

                <div style={{ display:"flex", gap:12, marginTop:28 }}>
                  <button onClick={() => setEtape(1)}
                    style={{ background:"white", border:"1.5px solid #E8DCC8", borderRadius:10, padding:"13px 20px", fontSize:14, fontWeight:600, color:"#7A5A3A", cursor:"pointer" }}>
                    ← Retour
                  </button>
                  <button className="btn-submit" onClick={handleSoumettre}
                    style={{ flex:1, padding:"13px", color:"white", border:"none", borderRadius:10, fontFamily:"'Space Grotesk',sans-serif", fontSize:15, fontWeight:700, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:8, boxShadow:"0 8px 20px rgba(196,68,26,0.30)" }}>
                    ✓ Créer mon compte
                  </button>
                </div>
              </>
            )}

          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}